import { ScreenerFilterOption } from '@api';
import { Button, CheckBox } from '@design';
import { highlight } from '@helpers';
import React, { ChangeEvent, CSSProperties } from 'react';

import {
  getIsOptionSelected,
  getIsPartiallyOrAllSelected,
  isOptionExpanded,
  mapOptions,
} from '../../utils';
import styles from './Node.module.scss';

export interface NodeProps {
  option: ScreenerFilterOption;
  displayCaret: boolean;
  level: number;
  selectedOptions: ScreenerFilterOption[];
  searchQuery: string;
  expandedItems: string[];
  onClickCaret: (values: string[], isExpanded: boolean) => void;
  onChangeCheckBox: (options: ScreenerFilterOption[], checked: boolean) => void;
}

export const Node = ({
  option,
  displayCaret,
  level,
  selectedOptions,
  searchQuery,
  expandedItems,
  onClickCaret,
  onChangeCheckBox,
}: NodeProps) => {
  const optionValue = option.value.code as string;
  const mappedOptions = mapOptions([option]);

  const handleChange = (_: string, e: ChangeEvent<HTMLInputElement>) => {
    onChangeCheckBox(mappedOptions, e.target.checked);
  };

  const handleClick = () => {
    const items = isExpanded
      ? mappedOptions.map(mo => mo.value.code)
      : [option.value.code];
    onClickCaret(items as string[], isExpanded);
  };

  const { isPartial } = getIsPartiallyOrAllSelected(option, selectedOptions);
  const isExpanded = isOptionExpanded({ expandedItems, option });
  return (
    <div
      className={styles.nodeWrapper}
      style={{ '--level': level } as CSSProperties}
    >
      {displayCaret && (
        <Button
          variant="empty"
          size="xsmall"
          iconName={isExpanded ? 'CaretDown' : 'CaretRight'}
          onClick={handleClick}
        />
      )}

      <CheckBox
        label={
          !!searchQuery.length
            ? highlight(option.name, searchQuery)
            : option.name
        }
        name={optionValue}
        checked={getIsOptionSelected(option, selectedOptions) || isPartial}
        partial={isPartial}
        onChange={handleChange}
      />
    </div>
  );
};
